
// src/web/components/diary-form.jsx

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import connect from '../../connects/diary-form'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  Card,
  CardTitle,
  CardText,
} from 'react-toolbox/lib/card'
import FontIcon from 'react-toolbox/lib/font_icon'
import Input from 'react-toolbox/lib/input'
import Dropdown from 'react-toolbox/lib/dropdown'
import Avatar from 'react-toolbox/lib/avatar'
import DiaryUploadFiles from './diary-upload-files.jsx'
import RithTextEditor from './rich-text-editor.jsx'
import ReportedDatePicker from './reported-date-picker.jsx'
import DiaryFormsKPIItem from './diary-forms-kpi-item.jsx'
import FileUploadButton from './file-upload-button.jsx'
import SavedDiary from './saved-diary.jsx'
import DiaryUrlLinks from './diary-url-links.jsx'
import DiaryFormsFields from './diary-forms-fields.jsx'
import ConfirmGoogleLogin from './confirm-google-login.jsx'
import diaryButtonTheme from './themes/diary-form-button.css'
import successButtonTheme from './themes/success-button.css'
import subjectInputTheme from './themes/subject-input.css'
import animation from './animation-css'
import { convertEmojiChar } from '../../helpers/emoji-helpers'
import { linkUI } from '../../helpers/form-validator'
import DraftSelectionDialog from './draft-selection-dialog.jsx'
import ReviewCard from './review-card.jsx'
import { mergeArray } from '../../helpers/store'
import _ from 'lodash'

const POST_TYPES=[
  { value: 'diary', icon: 'event_note' },
  { value: 'kpi', icon: 'insert_chart' },
  { value: 'memo', icon: 'assignment' }
]
const teststring = `評価: ⭐⭐⭐⭐☆ 4/5

<p><strong>良かった点:</strong></p>
<p>今日のタスクとその成果が明確に記述されており、日々の業務進捗が具体的に把握できます。</p>
<p>次の日の予定が詳細に記載されており、計画的な業務遂行が伺えます。</p>
<p>問題点が挙げられており、課題への意識が高いことがわかります。</p>
<br/>
<p><strong>改善点:</strong></p>
<p>問題点に対する改善策や解決方法の記述が不足しています。問題を指摘するだけでなく、具体的な解決策を検討しましょう。</p>
<p>日報の記述が一部簡潔すぎる箇所があります。もう少し詳細な情報を加えることで、日報の有用性をさらに高めることができます。</p>
<p>タスクの優先順位や、それに対する時間管理の記述が見られません。効率的な業務進行のためには、これらの情報も含めるとよいでしょう。</p>
<br/>
<p><strong>gamba活用のヒント:</strong></p>
<p>AWS Lambdaの新機能、レスポンスストリーミングを利用して、日報の内容をリアルタイムにフィードバックするシステムを構築してみましょう。例えば、日報に記載されたタスクの進捗状況や問題点を分析し、改善策を自動的に提案するLambda関数を開発することが考えられます。このような自動フィードバックシステムを導入することで、日報の質の向上と業務効率の向上が期待できます。</p>`
class DiaryForm extends PureComponent {
  state = { active: false, isReviewActive: false }
  validateAndSubmit = (ev)=> {
    this.props.ui.saveMessage && this.props.updateUI({ saveMessage: false })
    this.props.validateAndSubmit(this.props, ev)
  }
  onEditorInitialized = (editorHandlers)=> this.props.updateUI({ editorHandlers })
  onTemplateSelect = (name, attach_json, id)=> {
    if (id == 'last_diary') {
      if(attach_json && attach_json.category){
        (this.props.onChangeCategory(attach_json.category, this.props), this.props.updateUI({ fields: attach_json ? attach_json.fields : []}))
      }
    }else if(attach_json && attach_json.category){
      attach_json.category != 'memo' ?
        (this.props.onChangeCategory(attach_json.category, this.props),this.props.updateUI({ fields: attach_json ? attach_json.fields : []})):
        (this.props.onChangeCategory(attach_json.category, this.props),this.props.updateUI({ fields: attach_json ? attach_json.fields : [], subject: name}))
    }else {
      this.props.updateUI({ fields: attach_json ? attach_json.fields : [], subject: name })
    }
  }
  onUpdateField = (index, field)=> this.props.onUpdateField(this.props, index, field)
  onCancel = ()=> {
    this.props.ui.saveMessage && this.props.updateUI({ saveMessage: false })
    this.props.onCancel(this.props)
  }
  onChangeDate = (date)=> this.props.updateUI({ reported_at: date })
  onChangeEditor = ()=> this.props.onChangeEditor(this.props)
  onFocus = ()=> this.props.updateUI({ hasFocus: true })
  onAddLink = (link)=> this.props.onAddLink(this.props, link)
  onDeleteLink = (link)=> this.props.onDeleteLink(this.props, link)
  onCancelConfirmGapi = ()=> this.props.onCancelConfirmGapi(this.props)
  onSuccessConfirmGapi = ()=> this.props.onSuccessConfirmGapi(this.props)
  onChangeCategory = (category)=> this.props.onChangeCategory(category, this.props)
  openDraftSelectionDialog = () => this.setState({ active: true })
  closeDraftSelectionDialog = ()=> this.setState({ active: false })

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.savedDiaries && this.props.savedDiaries.length != 0 &&
        (!nextProps.savedDiaries || nextProps.savedDiaries.length == 0)) {
        this.closeDraftSelectionDialog()
    }
    // 編集対象の投稿が読み込まれたタイミングでスクロールポジションを先頭に移動する
    // もしくは投稿を編集中に、別の投稿を編集しようとした場合もスクロールを先頭に移動させる
    if (!this.props.isEditDiaryFetching && nextProps.isEditDiaryFetching && (nextProps.current || nextProps.ui.hasFocus) ||
        !this.props.current && nextProps.current)
      this.props.onScrollTop()
  }

  showUserSelectionDialog = ()=> this.props.showUserSelectionDialog(
    this.props.t('label:読んでみての宛先を追加'),
    true,
    'GROUP_MEMBERS_MENTION',
    this.props.group && this.props.group,
    this.props.ui.mentions,
    (users)=> this.props.updateUI({
      mentions: mergeArray('user_id', [], users),
    })
  )

  onSendChatGPT = () => {
    this.props.ui.editorHandlers && this.props.ui.editorHandlers.getValue((content) => {
      this.props.askGpt(content)
    })
  }

  onOpenReview = () => {
    this.props.setReviewTarget('form')
    this.props.onOpenReview()
  }

  onChangeValue = (ev, kpi, str) => {
    const ev_value = isNaN(parseFloat(ev.target.value)) ? 0 : parseFloat(ev.target.value)
    if (str == 'actual') {
      if (typeof kpi.total != 'undefined') {
        this.props.updateUI({
          values: Object.assign({}, this.props.ui.values, { [kpi.kpi_id]: ev_value }),
          total_values: Object.assign({}, this.props.ui.total_values, { [kpi.kpi_id]: kpi.total - kpi.actual + ev_value }),
          hasFocus:true
        })
      } else {
        this.props.updateUI({
          values: Object.assign({}, this.props.ui.values, { [kpi.kpi_id]: ev_value }),
          hasFocus:true
        })
      }
    } else {
      this.props.updateUI({
        values: Object.assign({}, this.props.ui.values, { [kpi.kpi_id]: ev_value - kpi.total + kpi.actual }),
        total_values: Object.assign({}, this.props.ui.total_values, { [kpi.kpi_id]: ev_value }),
        hasFocus: true
      })
    }
  }

  handleKeyPress = (ev) => {
    // Check if the pressed key is 'Enter' and element is input tag
    if (ev.target.tagName.toLowerCase() == 'input' && ev.key == 'Enter') {
      // Prevent the default action to avoid form submission
      ev.preventDefault()
    }
  }

  render() {
    const {
      t,
      ui,
      group,
      isPosting,
      isPostFailed,
      isSaving,
      isUploading,
      uploadedFiles,
      uploadedVideos,
      current,
      templates,
      templateActions,
      savedDiaries,
      validateAndSubmit,
      uploadFiles,
      onChangeEditor,
      onCancel,
      onWindowFocus,
      openGoogleCalendarPage,
      openGroupKPIPanel,
      updateUI,
      componentId,
      kpi,
      showKpi,
      showGoogleDoc,
      showGambaUrl,
      blinkEditForm,
      onAddLink,
      onDeleteLink,
      urlLinks,
      onCancelConfirmGapi,
      onSuccessConfirmGapi,
      onUpdateField,
      socketStatus,
      showUserSelectionDialog,
      chatGptReview,
      review,
      isFetching,
      isFetchFailed,
      reviewTarget,
      isReviewCompleted,
      isReviewEnable
    } = this.props

    return (
      <form onSubmit={this.validateAndSubmit} onKeyPress={this.handleKeyPress}>
        <Dropdown auto theme={diaryButtonTheme} source={POST_TYPES}
          disabled={current && current.status == 'committed'}
          template={(item)=> <span>&nbsp;<FontIcon value={item.icon} style={{ verticalAlign: 'bottom' }}/>&nbsp;{t('diary:' + item.value)}</span>}
          value={ui.category}
          onChange={this.onChangeCategory} />
        <div style={{ display: 'flex' }}>
          {ui.category != 'memo' &&
          <ReportedDatePicker category={ui.category}
            date={ui.reported_at}
            onChangeDate={this.onChangeDate} />}
          {ui.category == 'memo' &&
          <Input theme={subjectInputTheme}
            name="subject"
            type="text"
            required
            hint={t('label:ノートのタイトル')}
            error={ui.subjectError && t('error:タイトルを入力してください')}
            value={convertEmojiChar(ui.subject || '')}
            onChange={linkUI(this, 'subject')} />}

          <div style={{ marginLeft: 'auto', marginBottom: 4}}>
            {savedDiaries && savedDiaries.length != 0 && <Button raised
              className={ui.saveMessage ? diaryButtonTheme.save_button : ''}
              theme={diaryButtonTheme}
              onClick={this.openDraftSelectionDialog}
              disabled={ui.hasFocus}
              icon={ui.saveMessage && <FontIcon value='check_circle' className={diaryButtonTheme.save_msg}/>}
              label={t('label:下書き', { count: savedDiaries.length })}/>}
            <DraftSelectionDialog diaries={savedDiaries} 
              active={this.state.active} group={group}
              onClose={this.closeDraftSelectionDialog} isEdit={current} />
          </div>
        </div>


        {ui.category == 'kpi' && kpi && kpi.map((item)=>
          <DiaryFormsKPIItem key={item.kpi_id}
              kpi={item}
              showKpi={()=> showKpi(item.kpi_id)}
              onChange={this.onChangeValue}
              error={ui.values[item.kpi_id + 'Error']}
              value={ui.values[item.kpi_id]}
              total_error={ui.total_values[item.kpi_id + 'Error']}
              total_value={ui.total_values[item.kpi_id]}/> )}
        {ui.category == 'kpi' && (!kpi || kpi.length == 0) && <div style={{ margin: '5px' }}>
            {t('label:KPIがありません')}
            </div>}
        {group.is_admin && ui.category == 'kpi' &&
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '5px' }}>
            <Button icon="add" theme={successButtonTheme} raised
              label={t('label:KPIを作成')}
              onClick={openGroupKPIPanel} />
          </div>}

        <RithTextEditor 
            blinking={blinkEditForm}
            onEditorInitialized={this.onEditorInitialized}
            onChange={this.onChangeEditor}
            onFocus={this.onFocus}
            onTemplateSelect={this.onTemplateSelect}
            category={ui.category}
            templates={templates}
            templateActions={templateActions}
            showGoogleDoc={showGoogleDoc}
            showGambaUrl={showGambaUrl}
            onAddLink={this.onAddLink}
            onDrop={uploadFiles} />
        {ui.contentError && 
          <div><span className={diaryButtonTheme.error_msg}>{t('error:本文を入力してください')}</span></div>}

        <DiaryFormsFields fields={ui.fields} onUpdateField={this.onUpdateField} />
        <DiaryUrlLinks urlLinks={ui.urlLinks} onDeleteLink={this.onDeleteLink} />
        <DiaryUploadFiles componentId={componentId}/>
        {!ui.gapiReady && <ConfirmGoogleLogin open={ui.confirmGapi} onClose={this.onCancelConfirmGapi} onSuccess={this.onSuccessConfirmGapi} />}
        {ui.hasFocus && this.props.isOpenReviewPanel && reviewTarget == 'form' && <ReviewCard t={t} onCloseReview={this.props.onCloseReview}  isReviewCompleted={isReviewCompleted} onSendChatGPT={this.onSendChatGPT} review={review} isFetching={isFetching} isFetchFailed={isFetchFailed} />}
        {ui.hasFocus &&
          <div style={{ display: 'flex', marginBottom: '4px' }}>
            <Button
              raised={!(ui.mentions && ui.mentions.length > 0)}
              floating={(ui.mentions && ui.mentions.length > 0)}
              mini={(ui.mentions && ui.mentions.length > 0)}
              onClick={this.showUserSelectionDialog} 
              icon="person_add"
              theme={successButtonTheme}
              label={!(ui.mentions && ui.mentions.length > 0) && t('label:読んでみての宛先を追加')} />
              {ui.mentions && _.map(ui.mentions.slice(0, 5), (mention, i) => <Avatar image={mention.icon_image.thumb_url} style={{ marginLeft: 2 }}/>)}
              {ui.mentions && ui.mentions.length > 5 &&  <Button
              primary
              onClick={this.showUserSelectionDialog}
              icon='arrow_forward'
              label={t('label:他n人', { n: ui.mentions.length　-　5 }) + 'を' + t('label:すべて表示')} />}
          </div>
        }
        {ui.hasFocus && socketStatus != 'connected' && <span className={diaryButtonTheme.error_msg}>{t('error:インターネット接続に問題があります')}</span>}
        {ui.hasFocus && ui.postError && <div><span className={diaryButtonTheme.error_msg}>{t('error:データの送信に失敗しました')}</span></div>}
        {ui.hasFocus &&
          <div style={{ display: 'flex' }}>
            <Button raised primary
                {...animation(blinkEditForm)}
                theme={diaryButtonTheme}
                disabled={isPosting || isSaving || isUploading || ui.category == 'kpi' && (!kpi || kpi.length == 0)}
                icon="send"
                type="submit"
                label={t('label:投稿')} />
            <Button raised
                icon="auto_awesome"
                disabled={isFetching}
                theme={diaryButtonTheme}
                onClick={this.onOpenReview}
                label={'AIレビュー'} />
            <FileUploadButton raised
                theme={diaryButtonTheme}
                icon='add_a_photo'
                onChange={uploadFiles}
                label={t('label:添付')} />
            <Button raised
                icon="event_available"
                theme={diaryButtonTheme}
                onClick={openGoogleCalendarPage}
                label={t('label:カレンダー連携')} />
            <Button 
                icon="close"
                theme={diaryButtonTheme}
                style={{ marginLeft: 'auto' }}
                onClick={this.onCancel}
                label={t('label:閉じる')} />
          </div>
        }
      </form>
    )
  }
}

export const RawDiaryForm = DiaryForm
export default connect(DiaryForm)



// WEBPACK FOOTER //
// ./src/web/components/diary-form.jsx